class Do_Nothing {
    static path = 'do-nothing/do-nothing';

    constructor(mutator){
        this.addInput("", "");
        this.size = [110,50];
        this.bgcolor = '#ff7191';
        this.title = 'Do Nothing';
        this.desc = 'Do Nothing';
    }


    onDrawForeground(ctx) {
        if (this.flags.collapsed) {
            return;
        }

        let center_x = this.size[0] * 0.5;
        let center_y = this.size[1] * 0.5;

        ctx.fillStyle = this.properties.color;
        ctx.lineWidth = 2;

        // Draw the X
        ctx.beginPath();
        ctx.moveTo(center_x - 12, center_y - 12);
        ctx.lineTo(center_x + 12, center_y + 12);
        ctx.moveTo(center_x + 12, center_y - 12);
        ctx.lineTo(center_x - 12, center_y + 12);
        ctx.stroke();

        // Draw the circle
        ctx.beginPath();
        ctx.arc(center_x, center_y, 22, 0, 2 * Math.PI);
        ctx.stroke();

    };
}

module.exports = Do_Nothing
